import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'

import { usePackageReqs } from '../../api/package-req/queries/usePackageReqs'
import grFlagCircle from '../../imgs/flags/greece-circle.png'
import ukFlagCircle from '../../imgs/flags/uk-circle.png'
import usaFlagCircle from '../../imgs/flags/usa-circle.png'
import logo from '../../imgs/logo.png'
import logoutIcon from '../../imgs/logout_icon.svg'
import { setLoggedUserAction } from '../../store/userSlice'

export default function OfficeNavbar() {
  const history = useHistory()
  const dispatch = useDispatch()
  const hamburgerRef = useRef(null)
  const navMenuRef = useRef(null)
  const [isMobile, setIsMobile] = useState(false)
  const { loggedUser } = useSelector(state => state.user)

  const { data: packageRequestsData } = usePackageReqs()

  // Calculate total sum
  const shrinkReqs = packageRequestsData?.shrinkRequest ?? []
  const photoReqs = packageRequestsData?.photoRequest ?? []
  const returnReqs = packageRequestsData?.returnRequest?.filter(returnReq => returnReq.returnLabel) ?? []
  const uniteReqs = packageRequestsData?.uniteRequest ?? []
  const allReqsSum = shrinkReqs.length + photoReqs.length + returnReqs.length + uniteReqs.length

  useEffect(() => {
    setIsMobile(window.matchMedia('only screen and (max-width: 760px)').matches)
  }, [])

  const logOutHandler = async () => {
    localStorage.removeItem('cognito-tokens')
    dispatch(
      setLoggedUserAction({
        UserAttributes: null,
        Username: null,
        groups: [],
        permissions: {
          Admin: false,
          Agent: false,
          OfficeManager: false,
          SeniorAgent: false,
          Worker: false,
        },
      })
    )

    history.push('/')
  }

  function mobileMenu() {
    if (!isMobile) return
    hamburgerRef.current.classList.toggle('active')
    navMenuRef.current.classList.toggle('active')
  }

  return (
    <header className='header' data-bs>
      <nav className='navbar-office-cont'>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Link to='/' className='nav-logo'>
            <img alt='icon' width='50px' src={logo} />
          </Link>
          <div className='navbar-flag'>
            {loggedUser.UserAttributes['custom:warehouse'] == 'USA' && <img alt='flag' width='20px' src={usaFlagCircle} />}
            {loggedUser.UserAttributes['custom:warehouse'] == 'GR' && <img alt='flag' width='20px' src={grFlagCircle} />}
            {loggedUser.UserAttributes['custom:warehouse'] == 'UK' && <img alt='flag' width='20px' src={ukFlagCircle} />}
          </div>
        </div>
        <ul className='nav-menu navbar1-office' ref={navMenuRef}>
          <li className='office-nav-item'>
            <Link
              to='/office'
              className='nav-link1'
              onClick={() => {
                mobileMenu()
              }}
            >
              Add New Package +
            </Link>
          </li>
          <li className='office-nav-item'>
            <Link
              to='/office-ship'
              className='nav-link1'
              onClick={() => {
                mobileMenu()
              }}
            >
              Ship Packages
            </Link>
          </li>
          <li className='office-nav-item'>
            <Link
              to='/office-e&u'
              className='nav-link1'
              onClick={() => {
                mobileMenu()
              }}
            >
              Edit And Update
            </Link>
          </li>
          <li className='office-nav-item' style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
            <Link
              to='/office-packageRequests'
              className='nav-link1'
              onClick={() => {
                mobileMenu()
              }}
            >
              Package Requests
            </Link>
            <div className='notif-bubble-office-navbar'>{allReqsSum}</div>
          </li>
          <li className='office-nav-item'>
            <Link
              to='/office-print'
              className='nav-link1'
              onClick={() => {
                mobileMenu()
              }}
            >
              Print Lable for Package
            </Link>
          </li>
          <li className='office-nav-item'>
            <Link
              to='/office-checkForm'
              className='nav-link1'
              onClick={() => {
                mobileMenu()
              }}
            >
              Packages Check List
            </Link>
          </li>
          <li className='office-nav-item'>
            <Link
              to='/office-stats'
              className='nav-link1'
              onClick={() => {
                mobileMenu()
              }}
            >
              Stats
            </Link>
          </li>
          <li className='office-nav-item'>
            <Link
              to='/office-affiliate'
              className='nav-link1'
              onClick={() => {
                mobileMenu()
              }}
            >
              Affiliate
            </Link>
          </li>
          <li className='office-nav-item'>
            <Link
              to='/office-coupon'
              className='nav-link1'
              onClick={() => {
                mobileMenu()
              }}
            >
              Coupons
            </Link>
          </li>
          <li className='office-nav-item'>
            <Link
              to='/all-packages-view'
              className='nav-link1'
              onClick={() => {
                mobileMenu()
              }}
            >
              All Packages View
            </Link>
          </li>
          {/* <li className="office-nav-item">
            <Link
              to="/office-receive-shipments"
              className="nav-link1"
              onClick={() => {
                mobileMenu()
              }}
            >
              Receive Shipments
            </Link>
          </li> */}
          <li className='office-nav-item'>
            <Link
              to='/office-delayed-payments'
              className='nav-link1'
              onClick={() => {
                mobileMenu()
              }}
            >
              Delayed Payments
            </Link>
          </li>
          <li className='office-nav-item'>
            <Link
              to='/office-ship-barcode-gun'
              className='nav-link1'
              onClick={() => {
                mobileMenu()
              }}
            >
              Barcode Gun Ship
            </Link>
          </li>
          <li className='office-nav-item'>
            <Link
              to='/office-location'
              className='nav-link1'
              onClick={() => {
                mobileMenu()
              }}
            >
              Location
            </Link>
          </li>
        </ul>
        <img
          src={logoutIcon}
          className='logout-btn'
          onClick={() => {
            logOutHandler()
          }}
        />
        <div
          ref={hamburgerRef}
          className='hamburger'
          onClick={() => {
            mobileMenu()
          }}
        >
          <span className='bar'></span>
          <span className='bar'></span>
          <span className='bar'></span>
        </div>
      </nav>
    </header>
  )
}
